import { Routes } from '@angular/router';

import { PrivateRoutesGuard, PublicRoutesGuard } from '@core/guards';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'public',
    pathMatch: 'full',
  },
  {
    path: 'public',
    canActivate: [PublicRoutesGuard],
    loadComponent: () =>
      import('./pages/public/public.component').then(
        (m) => m.PublicLayoutComponent
      ),
    loadChildren: () => import('./pages/public/routes').then((m) => m.routes),
  },
  {
    path: 'private',
    canActivate: [PrivateRoutesGuard],
    loadComponent: () =>
      import('./pages/private/private-layout.component').then(
        (m) => m.PrivateLayoutComponent
      ),
    loadChildren: () => import('./pages/private/routes').then((m) => m.routes),
  },
  {
    path: '**',
    redirectTo: 'public',
    pathMatch: 'full',
  },
];
